import React from "react";

import { formatNumber } from "../utils/dashboardUtils";

const toneClasses = {
  blue: "bg-blue-50 text-blue-600 dark:bg-blue-500/10 dark:text-blue-300",
  orange:
    "bg-orange-50 text-orange-600 dark:bg-orange-500/10 dark:text-orange-300",
  emerald:
    "bg-emerald-50 text-emerald-600 dark:bg-emerald-500/10 dark:text-emerald-300",
  rose: "bg-rose-50 text-rose-600 dark:bg-rose-500/10 dark:text-rose-300",
  violet:
    "bg-violet-50 text-violet-600 dark:bg-violet-500/10 dark:text-violet-300",
};

export default function DashboardStatCard({
  icon: Icon,
  label,
  value,
  helper,
  tone = "blue",
  loading = false,
}) {
  return (
    <article className="rounded-3xl border border-slate-200 bg-white p-5 shadow-sm shadow-slate-200/60 transition hover:-translate-y-1 hover:shadow-lg hover:shadow-slate-200/80 dark:border-slate-800 dark:bg-slate-900 dark:shadow-none dark:hover:shadow-none">
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="text-sm font-medium text-slate-500 dark:text-slate-400">
            {label}
          </p>

          {loading ? (
            <div className="mt-3 h-8 w-20 animate-pulse rounded-xl bg-slate-100 dark:bg-slate-800" />
          ) : (
            <p className="mt-2 text-3xl font-bold tracking-tight text-slate-950 dark:text-white">
              {formatNumber(value)}
            </p>
          )}

          {helper && (
            <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
              {helper}
            </p>
          )}
        </div>

        {Icon && (
          <span
            className={`grid h-12 w-12 shrink-0 place-items-center rounded-2xl ${
              toneClasses[tone] || toneClasses.blue
            }`}
          >
            <Icon className="text-xl" />
          </span>
        )}
      </div>
    </article>
  );
}